import { render, staticRenderFns } from "./Advice.vue?vue&type=template&id=6aa3d236&scoped=true&"
import script from "./Advice.vue?vue&type=script&lang=js&"
export * from "./Advice.vue?vue&type=script&lang=js&"
import style0 from "./Advice.vue?vue&type=style&index=0&id=6aa3d236&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa3d236",
  null
  
)

export default component.exports